import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import Loading from '../modal/Loading';

class Books extends React.Component {
    state = { statments : [] }
    state = { LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}] }

    constructor(props, context) {
        super(props, context);
        this.state = {
            pageData: undefined
        };
    }
    
    componentDidMount() {
        if (new URLSearchParams(this.props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(this.props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            this.getLanguageInfo(new URLSearchParams(this.props.location.search).get("lang"));
            //console.log(this.state.LanguageInfo);
        }else{
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            this.getPage();
        }

        //this.getPage();
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         this.setLog('pages/log/books_'+this.props.match.params.bookgroupcode+'/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => this.setLog('pages/log/books_'+this.props.match.params.bookgroupcode+'/visit/'+err));
    }

    async setLog(Data) {
        await webapi.post(Data);
    }

    async getLanguageInfo(LanguageCode){
        const responseResultlanguageinfo = await webapi.get('pages/LanguageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            this.setState({LanguageInfo:responseResultlanguageinfo.data});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            this.setState({LanguageInfo: [{Code:"Fa",Title:"فارسی",Direction:"rtl"}]});
            //this.setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
        this.getPage();
    }
    
    async getPage() {
        if (this.state.LanguageInfo)
        {
            const pageList = await webapi.get('pages/datapages/301/'+this.state.LanguageInfo[0].Code);
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }else{
            const pageList = await webapi.get('pages/datapages/301/fa');
            //console.log(pageList);
            this.setState({
                pageData: pageList.data
            });
        }

        var AllBooksConst
        //console.log('bookgroupcode0:',this.props.match.params.bookgroupcode);
        if (this.props.match.params.bookgroupcode)
        {
            AllBooksConst = await webapi.get('book/booksofbookgroup/'+this.props.match.params.bookgroupcode+'/'+this.state.LanguageInfo[0].Code);
            //console.log('AllBooksConst:',AllBooksConst);
            this.setState({
                AllBooks: AllBooksConst.data
            });
            // this.setState({
            //     BookGroupTitle: AllBooksConst.data[0].Title
            // });
        }
        else
        {
            AllBooksConst = await webapi.get('book/allbooks/'+this.state.LanguageInfo[0].Code);
            //console.log('AllBooksConst3:',AllBooksConst);
            this.setState({
                AllBooks: AllBooksConst.data
            });
        }
        //console.log(this.state.AllBooks);
    }
    
    render() {
        if (this.state.pageData && this.state.LanguageInfo) {
            return  (
                <div>
                    <Header LanguageInfo = {this.state.LanguageInfo}/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            {
                                <h1 id="page_title">{this.state.pageData.length!==0 && this.state.pageData[0].F301!== undefined?this.state.pageData[0].F301:301/*کتاب ها */}</h1>
                            }
                        </div>
                    </div>
                    {
                        (this.state.AllBooks)
                        ?
                        <div className="container-fluid">
                            <div className="container container_70">
                                <table className="table_style">
                                    <thead>
                                        <tr>
                                            <th>{this.state.pageData.length!==0 && this.state.pageData[0].F39901!== undefined?this.state.pageData[0].F39901:39901/*ردیف*/}</th>
                                            <th>{this.state.pageData.length!==0 && this.state.pageData[0].F39902!== undefined?this.state.pageData[0].F39902:39902/*نام*/}</th>
                                            <th>{this.state.pageData.length!==0 && this.state.pageData[0].F39903!== undefined?this.state.pageData[0].F39903:39903/*وضعیت بارگذاری*/}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (this.state.AllBooks && this.state.AllBooks.length>0)
                                            ?
                                                this.state.AllBooks.map((book) =>{
                                                    return  (
                                                        <tr key= {book.Code}>
                                                            <td>
                                                                <p className="book_number">
                                                                    <span className="circle">
                                                                        {book.Code}
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p className="book_title">
                                                                   { 
                                                                        book.HyperLinked===1
                                                                        ?
                                                                        <a href={"/book/"+book.Code+"?lang="+this.state.LanguageInfo[0].Code}>
                                                                            {book.Title}
                                                                        </a>
                                                                        :
                                                                        book.Title
                                                                    }
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <p className="book_stat">
                                                                    {book.Description}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            :
                                            null
                                        }
                                    </tbody>
                                </table>                                 
                            </div>
                        </div>
                        :
                        <div>
                            <div style={{height:"400px",width:"100%", clear:"both"}}></div>
                            <Loading LoadingShow={true} />
                        </div>
                    }
                    <Footer  Lang = {this.state.LanguageInfo[0].Code}/>
                </div>  
            )
        }
        else
        {
            return (
                <div></div>
            )
        }
    }
 }

 export default Books;